<template>
<div class="text-center">
  <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
